<template>
<div>
    <div class="searchCont">
        <div class="searchArtifact">
            <input type="text"  placeholder=""/>
            <button class="searchBtn">搜索</button>
        </div>
       

    </div>

</div>
</template>

<script>



export default {
    name:'',
    components: {

    },

    props: {

       
    },
   
    data(){
        return {

        }
    },

     computed:{
       
    },
    created() {

    },

    mounted() {
     
    }
    ,
    methods:{
       


    }
}
</script>

<style scoped>

.searchCont {
    
}


.searchArtifact input {
    padding:10px 12px 10px 35px;
    border:none;
    outline: none;
    border-radius:4px;
    box-sizing: border-box;
    background:url('../../assets/images/search_icon.png') no-repeat 10px center rgba(248,248,248,1);
    background-size:16px auto;
    font-size:14px;
    border:1px solid rgba(199,199,199,1);
    width:332px;

}

.searchBtn {
    border:none;
    outline: none;
    border-radius:4px;
    padding:0px 20px;
    font-size:14px;
    border:1px solid rgba(199,199,199,1);
    color:#0173FF;
    cursor: pointer;
    box-sizing: border-box;
    height: 38px;
    margin-left:3px;

}

    
</style>


// WEBPACK FOOTER //
// src/components/common/search.vue